import SignaturePad from 'signature_pad';

const SignaturePadHook = {
  mounted() {
    this.input = this.el.querySelector('[data-signature-pad=input]');
    this.canvas = this.el.querySelector('[data-signature-pad=canvas]');

    if (!!this.input.value) {
      this.initialize();
      this.restore();
    } else {
      this.el.addEventListener('initializeSignaturePad', () => {
        console.log('init call');

        window.requestAnimationFrame(() => {
          this.initialize();
        });
      });
    }

    this.el.addEventListener('clear', () => {
      this.signaturePad.clear();
      this.updateInputValue();
    });
  },

  initialize() {
    this.signaturePad = new SignaturePad(this.canvas);

    this.signaturePad.addEventListener('endStroke', () => {
      this.updateInputValue();
    });

    window.addEventListener('resize', this.resizeCanvas.bind(this));

    this.resizeCanvas();
    // this.updateInputValue();
  },

  updateInputValue() {
    this.input.value = this.getValue();
    this.input.dispatchEvent(new Event('input', { bubbles: true }));

    this.el.toggleAttribute('data-has-value', !this.signaturePad.isEmpty());
  },

  getValue() {
    if (this.signaturePad.isEmpty()) {
      return '';
    } else {
      return this.signaturePad.toDataURL('image/svg+xml');
    }
  },

  restore() {
    this.signaturePad.fromDataURL(this.input.value);
    this.resizeCanvas();
  },

  resizeCanvas() {
    const ratio = Math.max(window.devicePixelRatio || 1, 1);

    this.canvas.width = this.canvas.offsetWidth * ratio;
    this.canvas.height = this.canvas.offsetHeight * ratio;
    this.canvas.getContext('2d').scale(ratio, ratio);

    // otherwise isEmpty() might return incorrect
    if (this.signaturePad) {
      this.signaturePad.clear();
    }
  },
};

export default SignaturePadHook;
